import { useTranslation } from 'hooks/use-translation';
import React, { FC, useEffect, useRef } from 'react';
import styles from './styles.scss';
import { appointmentSource } from '@services/test-form';
import { setOpenHomeTime, getOpenHomeTime } from '@utils/testForm';
import { history } from '@store/history';

type IProps = {
	onClick?: () => void;
};

const AppointmentSection: FC<IProps> = (props) => {
	const { onClick } = props;
	const { transData } = useTranslation('home.appointment');
	const timeVal = useRef(0);

	//测试弹窗--接口埋点 pv
	// useEffect(() => {
	// 	const time = getOpenHomeTime();
	// 	appointmentSource({ eventType: 1, landingPageId: 1, duration: time ? new Date().getTime() - Number(time) : undefined });
	// 	setOpenHomeTime();
	// }, []);

	//接口埋点 uv
	// useEffect(() => {
	// 	timeVal.current = new Date().getTime();
	// 	return () => {
	// 		if (timeVal.current) {
	// 			appointmentSource({ eventType: 1, landingPageId: 1, duration: new Date().getTime() - timeVal.current });
	// 		}
	// 	};
	// }, []);
	const dueToPage = () => {
		history.push(`/en/booking-page`);
	};

	return (
		<section className={styles['ac-appointment']} id="appointment">
			<div className={styles['ac-appointment-container']}>
				<div className={styles['ac-appointment-content']}>
					<p className={styles['introduce']}>Tailored 1-on-1 <br/> Online Tutoring for  <br/> Every Child</p>
					<div className={styles['info-text']}>
						<p><i className={styles['icon']}></i>Affordable 50-minute Lessons</p>
						<p><i className={styles['icon']}></i>Handpicked Tutors</p>
						<p><i className={styles['icon']}></i>500,000+ Students</p>
						<p><i className={styles['icon']}></i>Increase grades within just a few lessons</p>
					</div>
					<button onClick={() =>dueToPage()} className={styles['appointment-img-4']}>BOOK YOUR FREE TRIAL</button>
					{/* <img className={styles['appointment-img-5']} loading="lazy" src="https://web-data.zmlearn.com/image/Vux1THerEXK9tQZtXU2v6/score.png" alt="" /> */}
				</div>
				<div className={styles['ac-appointment-img']}>
					<img className={styles['appointment-img-2']} loading="lazy" src="https://web-data.zmlearn.com/image/aodi1t91TFHit1FCoPodJq/man.png" alt="" />
				</div>
			</div>
		</section>
	);
};

export default AppointmentSection;
